'use client';

import AccordionPanel from 'components/AccordionPanel';
import { FaqItem } from 'types/landingPage';

interface FaqAccordionProps {
  faqs: FaqItem[];
  startOpen?: boolean;
}

const FaqAccordion: React.FC<FaqAccordionProps> = ({
  faqs,
  startOpen = true,
}) => {
  return (
    <ul className="accordion-container">
      {faqs.map((faq, index) => (
        <li key={index}>
          <AccordionPanel
            headline={faq.question}
            startOpen={startOpen}
            answer={faq.answer}
          ></AccordionPanel>
        </li>
      ))}
    </ul>
  );
};

export default FaqAccordion;
